<template>
  <!-- Modal -->
  <div>
    <div>
      <div
        class="modal fade in modal-active show"
        aria-modal="true"
        id="modal-add-admin"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="text-center mt-4">
              <h5 class="modal-title text-center" id="exampleModalLabel">
                Tambahkan Admin Baru
              </h5>
            </div>
            <div class="modal-body">
              <form action="" @submit.prevent="submitAdmin">
                <div class="mb-3">
                  <label for="message-text" class="col-form-label"
                    >Username</label
                  >
                  <input v-model="username" type="text" class="form-control" />
                </div>
                <div class="mb-3">
                  <label for="message-text" class="col-form-label">Email</label>
                  <input v-model="email" type="email" class="form-control" />
                </div>
                <div class="mb-3">
                  <label for="message-text" class="col-form-label"
                    >Password</label
                  >
                  <input
                    v-model="password"
                    type="password"
                    class="form-control"
                  />
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Tutup
                  </button>
                  <button
                    type="submit"
                    value="Add Admin"
                    class="btn btn-primary"
                    data-bs-dismiss="modal"
                  >
                    Tambahkan Admin
                  </button>
                </div>
              </form>
            </div>
            <!-- <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <input type="submit" value="Add Admin" class="btn btn-primary"/>
              </div> -->
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="modal-list-admin"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-title text-center mt-2">
            <h5 class="text-center bold">List Admin</h5>
          </div>
          <div class="modal-body">
            <div>
              <table class="table table-bordered text-center">
                <thead>
                  <tr>
                    <th style="color:black">No</th>
                    <th style="color:black">Admin Name</th>
                    <th style="color:black">Email</th>
                  </tr>
                </thead>
                <tbody v-for="(admin, index) in puskesmas.Admins" :key="index">
                  <tr>
                    <th>{{ index + 1 }}</th>
                    <td>{{ admin.username }}</td>
                    <td>{{ admin.email }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ListAdmin",
  data: function () {
    return {
      username: "",
      email: "",
      password: "",
      // getSchedule : this.sched
    };
  },
  computed: {
    puskesmas() {
      return this.$store.state.puskesmasDetail;
    },
    getPuskesmasId() {
      return this.$route.params.id;
    },
  },
  methods: {
    submitAdmin() {
      console.log('asuuuuuuuup admin add');
      this.$store.commit("SETLOADING", true);
      console.log("masuk submit modal list admin");
      const admin = {
        username: this.username,
        email: this.email,
        password: this.password,
        puskesmas_id: this.getPuskesmasId,
      };
      console.log("sampe sini");
      this.$store.commit("POSTADMIN", admin);
      this.$store
        .dispatch("postAdmin")
        .then((response) => {
          console.log(response);
          const puskesmasId = this.getPuskesmasId;
          this.$store.commit("SETLOADING", false);
          if (puskesmasId) {
            this.$vToastify.success({
              title : 'Sukses!',
              body: `Anda menambahkan ${response.data.username} sebagai ${response.data.role}`,
              theme : 'light'
            });
            this.$store.dispatch("fetchPuskesmasDetail");
            this.username = "";
            this.email = "";
            this.password = "";
          } else {
            this.$vToastify.success({
              title : 'Sukses!',
              body: `Anda menambahkan ${response.data.username} sebagai ${response.data.role}`,
              theme : 'light'
            });
            this.$store.dispatch("fetchPuskesmas");
            this.username = "";
            this.email = "";
            this.password = "";
          }
        })
        .catch((err) => {
          this.$store.commit("SETLOADING", false);
          this.$vToastify.error({
            title : 'Gagal!',
            body: err.response.data.message,
            theme : 'light'
          });
           this.username = "";
            this.email = "";
            this.password = "";
          console.log(err.response.data.message);
        });
    },
  },
};
</script>

<style></style>
